// Pure helpers + constants shared by the Dashboard page and its panels.
import { eventConfig } from "@/config/eventConfig";

// Resolve a referral code / invited_by value to a friendly adviser name.
const ADVISER_BY_CODE = (() => {
  const map = {};
  (eventConfig.advisers || []).forEach((a) => {
    if (a && a.code) map[String(a.code).toLowerCase()] = a.name;
  });
  map["nicholas"] = "Nicholas Lee";
  return map;
})();

export const DIRECT_LABEL = "Direct / none";

export function resolveAdviserLabel(key) {
  if (!key) return DIRECT_LABEL;
  const k = String(key).toLowerCase().trim();
  return ADVISER_BY_CODE[k] || key;
}

export const BAR_COLORS = ["#F7B838", "#1F9188", "#112A43", "#FFD16F", "#126F6A", "#647384"];

// Traffic channel constants (module-scope so they're stable across renders).
export const CHANNELS = ["WhatsApp", "Instagram", "Facebook", "Other"];
export const CHANNEL_COLORS = {
  WhatsApp: "#1F9188",
  Instagram: "#F7B838",
  Facebook: "#112A43",
  Other: "#647384",
};
export const CHANNEL_SHORT = { WhatsApp: "WA", Instagram: "IG", Facebook: "FB", Other: "Other" };

export const normCode = (c) => String(c || "").toUpperCase().trim();
export const emptyChannels = () => CHANNELS.reduce((a, c) => ({ ...a, [c]: 0 }), {});

const CSV_COLUMNS = [
  ["created_at", "Registered At"],
  ["full_name", "Full Name"],
  ["email", "Email"],
  ["mobile", "Mobile"],
  ["age_range", "Age Range"],
  ["invited_by", "Invited By"],
  ["biggest_question", "Biggest CPF Question"],
  ["marketing_consent", "Marketing Consent"],
  ["reminders_sent", "Reminders Sent"],
];

const ATTR_COLUMNS = [
  "referral_code",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "landing_page_url",
  "first_visit_at",
];

function csvEscape(val) {
  if (val === null || val === undefined) return "";
  const s = String(val).replace(/"/g, '""');
  return `"${s}"`;
}

export function toCSV(items) {
  const header = [...CSV_COLUMNS.map((c) => c[1]), ...ATTR_COLUMNS];
  const rows = items.map((it) => {
    const base = CSV_COLUMNS.map(([k]) => csvEscape(it[k]));
    const attr = it.attribution || {};
    const attrVals = ATTR_COLUMNS.map((k) => csvEscape(attr[k]));
    return [...base, ...attrVals].join(",");
  });
  return [header.map(csvEscape).join(","), ...rows].join("\r\n");
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-SG", { dateStyle: "medium", timeStyle: "short" });
  } catch (e) {
    return iso;
  }
}

// Trigger a browser download for a Blob or data URL.
export function downloadFile(href, filename) {
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export const PANEL_CLASS =
  "mt-8 rounded-2xl bg-white border border-[rgba(17,42,67,0.10)] shadow-[0_8px_24px_rgba(7,21,36,0.05)]";
